import { createSelectField } from 'components';
import { createOptions } from 'options';
import { campaingGoals } from './types';

const goalOptions = createOptions(campaingGoals);
export const CampaignGoalField = createSelectField(goalOptions, { simple: true });
